module.exports = __webpack_public_path__ + "static/img/our-people-we-live-quote.5776178.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-quote.jpg
// module id = PgSc
// module chunks = 0